import { render, staticRenderFns } from "./block-offer.vue?vue&type=template&id=d1ebae3c&scoped=true"
import script from "./block-offer.vue?vue&type=script&lang=js"
export * from "./block-offer.vue?vue&type=script&lang=js"
import style0 from "./block-offer.vue?vue&type=style&index=0&id=d1ebae3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ebae3c",
  null
  
)

export default component.exports